import { MFA_REMEMBER_ME_KEY, MFA_ASK_ME_LATER_KEY, MFASessionStorageOktaUserNameKey, UserLoginEmailSessionTokenKey } from '../constants'
import { createSha256Hash } from './cryptographyUtils'

export function getMfaLoginUsernameSessionStorageValue() {
    const loginUsername = sessionStorage.getItem( UserLoginEmailSessionTokenKey ) // get encrypted login username from session storage
    return loginUsername
}

export function getMfaOktaUsernameLocalStorageKey() {
    const encryptedUsername = getMfaLoginUsernameSessionStorageValue()
    const oktaUserNameKey = `${ encryptedUsername }_${ MFASessionStorageOktaUserNameKey }` // based on this, get the oktaUsername
    return oktaUserNameKey
}

export function getLocalStorageOktaUserName() {
    const key = getMfaOktaUsernameLocalStorageKey()
    return localStorage.getItem( key )
}

export function setUserLoginValueOnSessionStorage( loginEmail ){
    const encryptedLoginEmail = createSha256Hash( loginEmail )
    // the value is encrypted here for security reasons
    sessionStorage.setItem( UserLoginEmailSessionTokenKey, encryptedLoginEmail )
}

export function getMfaRememberLocalStorageKey() {
    const oktaUserNameKey = getLocalStorageOktaUserName()
    if( !oktaUserNameKey ) return null
    return `${ oktaUserNameKey }_${ MFA_REMEMBER_ME_KEY }`
}

export function getAskMeLaterLocalStorageKey() {
    const oktaUserNameKey = getLocalStorageOktaUserName()
    if( !oktaUserNameKey ) return null
    return `${ oktaUserNameKey }_${ MFA_ASK_ME_LATER_KEY }`
}

export function getMfaRememberLocalStorageKeyByLoginEmailHash() {
    const key = getMfaLoginUsernameSessionStorageValue()
    if( !key ) return null
    return `${ key }_${ MFA_REMEMBER_ME_KEY }`
}

export function getAskMeLaterLocalStorageKeyByLoginEmailHash() {
    const key = getMfaLoginUsernameSessionStorageValue()
    if( !key ) return null
    return `${ key }_${ MFA_ASK_ME_LATER_KEY }`
}

export function setMfaOktaUsernameLocalStorageValue( value ) {
    const oktaUserNameKey = getMfaOktaUsernameLocalStorageKey()
    setLocalStorageItemByKey( oktaUserNameKey, value )
}

export function setLocalStorageItemByKey( key, value ) {
    localStorage.setItem( key , value )
}

export function setMfaRememberMeDataOnLocalStorage( mfaRememberMeData ) {
    const key = getMfaRememberLocalStorageKey()
    if( !key ) return
    setLocalStorageItemByKey( key , mfaRememberMeData )
}

export function setAskMeLaterDataOnLocalStorage( askMeLaterData ) {
    const key = getAskMeLaterLocalStorageKey()
    if( !key ) return
    setLocalStorageItemByKey( key , askMeLaterData )
}

export function getMfaRememberMeLocalStorageValue() {
    let key = getMfaRememberLocalStorageKey()
    if( !key ) // so there is no previous login with this email address, but maybe there is one with the other one of the same account. One is the okta oktausername and the other one is the profile email
    {
        key = getMfaRememberLocalStorageKeyByLoginEmailHash()
    }
    
    return localStorage.getItem( key )
}

export function getAskMeLaterLocalStorageValue() {
    let key = getAskMeLaterLocalStorageKey()
    if( !key ) // so there is no previous login with this email address, but maybe there is one with the other one of the same account. One is the okta oktausername and the other one is the profile email
    {
        key = getAskMeLaterLocalStorageKeyByLoginEmailHash()
    }
    
    return localStorage.getItem( key )
}

export function removeLocalStorageItemByKey( key ) {
    localStorage.removeItem( key )
}

export function removeMfaRememberLocalStorageItem() {
    const key = getMfaRememberLocalStorageKey()
    if( !key ) return
    removeLocalStorageItemByKey( key )
}

export function removeAskMeLaterLocalStorageItem() {
    const key = getAskMeLaterLocalStorageKey()
    if( !key ) return
    removeLocalStorageItemByKey( key )
}

export function mfaRememberMeLocalStorageValueExists() {
    const encryptedOktaUsernameKey = getMfaRememberLocalStorageKey()
    if( !encryptedOktaUsernameKey ) return false
    const item = localStorage.getItem( encryptedOktaUsernameKey )
    return item != null
}